import SupportFeeElement from './support_fee_element';

export default SupportFeeElement;
